// src/components/CustomSwitch.tsx
import React from 'react';
import { Switch, SwitchProps, FormControlLabel, FormHelperText } from '@mui/material';
import { useController, Control } from 'react-hook-form';

type CustomSwitchProps = SwitchProps & {
    label: string;      // Label for the switch control
    name?: string;      // Field name for react-hook-form
    control?: Control<any>;  // Control object from react-hook-form
};

const BaseSwitch: React.FC<CustomSwitchProps & { field?: any; fieldState?: any }> = (props) => {
    const { label, field, fieldState, ...rest } = props;
    return (
        <>
            <FormControlLabel
                control={
                    <Switch
                        // Bind checked value to field value (ensuring it is boolean)
                        checked={!!field?.value}
                        // Update the form state on change using the event target's checked status
                        onChange={(event) => field.onChange(event.target.checked)}
                        {...rest}
                    />
                }
                label={label}
            />
            {fieldState?.error && (
                <FormHelperText error>{fieldState.error.message}</FormHelperText>
            )}
        </>
    );
};

const ControlledSwitch: React.FC<CustomSwitchProps> = (props) => {
    const { name, control } = props;
    const { field, fieldState } = useController({ name: name!, control: control! });
    return <BaseSwitch {...props} field={field} fieldState={fieldState} />;
};

const CustomSwitch: React.FC<CustomSwitchProps> = (props) => {
    const { name, control } = props;
    return control && name ? <ControlledSwitch {...props} /> : <BaseSwitch {...props} />;
};

export default CustomSwitch;
